import { Card, CardContent } from '../ui/card';
import { Check } from 'lucide-react';
import { RatingStars } from '../RatingStars';

export const TestimonialCard = ({ testimonial }) => (
<Card data-testid={`testimonial-card-${testimonial.id}`} className="testimonial-card bg-gradient-to-br from-gray-900 to-gray-950 border-2 border-red-900/40 hover:border-yellow-400/50 transition-all duration-300 transform hover:scale-105">
                <CardContent className="pt-6">
                  <div className="flex mb-4">
                    <RatingStars rating={testimonial.rating} />
                  </div>
                  <p className="text-gray-300 mb-6 italic leading-relaxed text-sm">"{testimonial.text}"</p>
                  <div className="flex items-center justify-between border-t border-red-900/30 pt-4">
                    <div>
                      <p className="font-semibold text-white">{testimonial.name}</p>
                      <p className="text-sm text-red-400">{testimonial.city}</p>
                    </div>
                    <Check className="w-6 h-6 text-green-500" />
                  </div>
                </CardContent>
              </Card>
);
